type VehicleDisplayNameProps = {
  vehicleDetails?: any
}
const VehicleDisplayName = ({ vehicleDetails }: VehicleDisplayNameProps) => {
  if (!vehicleDetails || vehicleDetails === null) {
    return ''
  }
  const displayName =
    vehicleDetails.displayName ||
    vehicleDetails.vehicleGroupTypeName ||
    vehicleDetails.vehicleTypeName ||
    ''
  if (vehicleDetails.category === 'Taxi') {
    return displayName
  } else {
    return `${vehicleDetails.category}: ${displayName}`
  }
}
export default VehicleDisplayName
